/* globals _ */
const { extend, each, pick, sortBy } = _;
import View from '../views/base';

export default View.extend( {
	tagName: 'ul',

	modelView: View,

	collection: null,

	events: {},

	elements: {
		$childwrap: '.-children',
	},

	listeners: {
		'collection reset': 'resetChildren',
		'collection add': 'addChild',
		'collection remove': 'removeChild',
		'collection sort': 'sortChildren',
		'collection update': 'renderStatus',
	},

	initialize: function( options ) {
		this.children = [];
		this.viewsByModel = {};
		this.childOptions = {};

		extend( this, pick( options, 'collection', 'childOptions', 'childSort' ) );

		var self = this;
		this._onViewEvent = function( event ) {
			var args = Array.prototype.slice.apply( arguments );

			args[ 0 ] = 'child:' + event;
			args.splice( 1, 0, this );

			View.prototype.trigger.apply( self, args );
		};

		View.prototype.initialize.apply( this, arguments );
	},

	at: function( index ) {
		return this.children[ index ];
	},

	get: function( id ) {
		var model = this.collection.get( id );
		return model ? this.viewsByModel[ model.cid ] : null;
	},

	each: function( iteratee ) {
		each( this.children, iteratee, this );
		return this;
	},

	callEach: function( method ) {
		var args = Array.prototype.slice.call( arguments, 1 );

		if ( typeof method !== 'function' ) {
			method = this.modelView.prototype[ method ];
		}

		return this.each( function( child ) {
			method.apply( child, args );
		} );
	},

	insertChild: function( child ) {
		this.$childwrap.append( child.el );
	},

	addChild: function( model, collection, options = {} ) {
		var viewOptions = extend( {
			model,
			parent: this,
		}, this.childOptions );

		var view = new this.modelView( viewOptions );

		// Insert in the same place as it was in the collection
		var index = options.at;
		if ( index === null || typeof index === 'undefined' || index > this.length ) {
			index = this.children.length;
		} else
		if ( index < 0 ) {
			index += this.children.length + 1;
		}
		this.children.splice( index, 0, view );

		this.viewsByModel[ model.cid ] = view;
		view.on( 'all', this._onViewEvent );

		this.insertChild( view.render() );

		this.trigger( 'renderChild', view );

		return this;
	},

	removeChild: function( model ) {
		var view = this.viewsByModel[ model.cid ];
		delete this.viewsByModel[ model.cid ];
		if ( typeof view !== 'undefined' ) {
			view.remove();
			view.off( 'all', this._onViewEvent, this );
		}

		var index = this.children.indexOf( view );
		this.children.splice( index, 1 );

		return this;
	},

	sortChildren: function() {
		this.each( function( child ) {
			child.$el.detach();
		} );
		this.children = [];

		var models = this.collection.models;
		if ( this.childSort ) {
			let [ comparator, order ] = this.childSort;
			if ( typeof comparator !== 'function' ) {
				comparator = model => model.get( comparator );
			}

			models = sortBy( this.collection.models, comparator );

			if ( order === 'desc' ) {
				models.reverse();
			}
		}

		models.forEach( model => {
			var view = this.viewsByModel[ model.cid ];
			if ( view ) {
				this.children.push( view );
				this.insertChild( view );
			}
		} )

		return this;
	},

	resetChildren: function() {
		this.callEach( 'remove' );

		this.children = [];
		this.viewsByModel = {};
		this.collection.each( model => this.addChild( model ) );

		this.renderStatus();

		return this;
	},

	render: function() {
		View.prototype.render.apply( this, arguments );

		if ( this.$childwrap.length === 0 ) {
			this.$childwrap = this.$el;
		}

		if ( this.$childwrap[ 0 ].tagName.toLowerCase() === 'ul' ) {
			this.childOptions.tagName = 'li';
		}

		this.resetChildren();

		return this;
	},

	renderStatus: function() {
		this.$( '.-count' ).attr( 'data-value', this.children.length );
		this.$el.toggleClass( 'empty', this.children.length === 0 );
	},

	rebind: function( collection ) {
		this.collection = collection;

		this.render();
		this.listenToObjects();

		this.trigger( 'rebind' );

		return this;
	},

	reset: function() {
		if ( this.collection ) {
			this.collection.reset();
		}
		this.trigger( 'reset' );
	},
} );
